import React from "react";

export default function ColorFrame16({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="138"
          cy="153"
          r="111"
          fill="white"
          stroke="#FF5130"
          strokeWidth="20"
        />
        <path
          d="M88.055 11.5861C103.117 -2.90409 122.736 6.83528 129.307 12.8728C138.388 6.39351 151.235 -0.822238 167.626 8.89689C181.802 17.3026 182.591 39.3792 167.626 58.5963C151.457 79.3596 127.978 92.3918 127.978 87.9741C127.978 75.1322 106.844 65.2369 94.2182 58.5963C77.3506 49.725 72.9931 26.0762 88.055 11.5861Z"
          fill="#E1472A"
        />
        <path
          d="M89.8327 9.72225C104.754 -4.76789 124.189 4.97148 130.699 11.009C139.695 4.52971 152.422 -2.68604 168.66 7.03309C182.703 15.4388 183.485 37.5154 168.66 56.7325C152.642 77.4958 129.382 90.528 129.382 86.1103C129.382 73.2684 108.447 63.3731 95.9382 56.7325C79.2283 47.8612 74.9115 24.2124 89.8327 9.72225Z"
          fill="#FF5130"
        />
        <path
          d="M126.979 32.4366C137.26 22.3925 152.148 28.2516 156.633 32.4366C162.832 27.9454 172.542 21.8213 182.624 30.1236C190.545 36.6469 192.566 50.1596 180.029 64.2901C170.446 75.0902 157.618 85.1889 156.633 82.9536C152.588 73.7687 141.757 68.5687 132.976 64.2901C120.725 58.3199 116.698 42.4808 126.979 32.4366Z"
          fill="#E1472A"
        />
        {children}
      </g>
    </svg>
  );
}
